export default __webpack_public_path__ + "static/media/tres_leches.f2a19538.jpg";